import { render } from "./aPrintBtn.vue?vue&type=template&id=40233770"
import script from "./aPrintBtn.vue?vue&type=script&lang=js"
export * from "./aPrintBtn.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__